export enum PageType {
    ArtistPage = 'artist-page',
    CityPage = 'city-page',
    CheckoutPage = 'checkout',
    EventSeriesPage = 'series-page',
    GenrePage = 'genre-page',
    MyAccountPage = 'my-account-page',
    PerformancePage = 'performance-page',
    VenuePage = 'venue-page',
}
